<template>
	<div >
		<Cover :productDetail="productDetail"></Cover>
		<Jobs :productDetail="productDetail"></Jobs>
    <Header @click="changeDetail"></Header>

	</div>
</template>

<script>
import {
  getJson
} from "@/utils/axios";
	import Cover from "./cover.vue"
	import Jobs from "./jobs.vue"
import Header from "../header.vue";

	export default {
		data(){
			return{
				initiate: "",
        productDetail:{}
			}
		},
		components: {
      Header,
			Cover, Jobs
		},
    created() {
      // 等待 Header 首次加载完菜单后通过事件传入 id
    },
    mounted() {
      const id = this.$route.query.id;
      if (id) this.getHotJobs(id);
    },
    methods: {
      changeDetail(e){
        this.getHotJobs(e.id)
      },
      getHotJobs(id) {
        if(!id) return
        getJson(`/content/productDetail/${id}`, {}, res => {
          this.productDetail=res.data
          // console.log(id,'首次/切换获取详情')
          // console.log(res,'获取详情')
        });
      },
			fucClick(item){
				this.initiate = item.title;
			},
			isOpen(val) {
				this.chanOpenState = val;
			},
		},
	}
</script>

<style>
</style>
